import vehicleTypeService from "@/api/vehicleTypeService";

const state = {
    allVehicleTypes: [],
}

const getters = {
    getVehicleTypes: (state, getters, rootState, rootGetters) => rootGetters.getVehicleTypes,
    allVehicleTypes: state => state.allVehicleTypes,
}
const actions = {
    async getAllVehicleTypes({ commit}) {
        const response = await vehicleTypeService.getAllVehicleTypes();
        commit('allVehicleTypes',response.data)
    },
    async addVehicleType({ commit }, vehicleTypes) {
        const response = await vehicleTypeService.addVehicleTypes(vehicleTypes);
        if(response.data.status){
        commit('addVehicleType', response.data.result ,{ root: true });
        }
        return response.data;
    },
    async updateVehicleType({ commit }, vehicleType) {
        const id = vehicleType.id;
        //delete vehicleType.id;
        const response = await vehicleTypeService.updateVehicleTypes(id, vehicleType);
        commit('updateVehicleType', response.data.result, { root: true });
    },
    async removeVehicleType({ commit }, id) {
        await vehicleTypeService.removeVehicleType(id);
        commit('removeVehicleType', id, { root: true });
    }
}
const mutations = {
    allVehicleTypes(state, data) {
        state.allVehicleTypes = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}






